import { render, staticRenderFns } from "./TransportManage.vue?vue&type=template&id=ccb11a0c"
import script from "./TransportManage.vue?vue&type=script&lang=js"
export * from "./TransportManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports